import { menuAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const config = createMultiStyleConfigHelpers(menuAnatomy.keys);

const baseStyle = config.definePartsStyle({
  list: {
    zIndex: 'dropdown',
  },
  item: {
    color: 'white',
    _light: {
      color: 'texas.bg.800',
      _focusWithin: { backgroundColor: 'blackAlpha.50' },
      _hover: { backgroundColor: 'blackAlpha.50' },
    },
  },
  groupTitle: {
    _light: {
      color: 'texas.bg.800',
    },
  },
});

const variants = {
  table: {
    button: {
      background: 'transparent',
      color: 'White',
      _light: {
        color: 'black',
      },
    },
  },
  entityDirectory: {
    button: {
      background: 'transparent',
      color: 'entityDirectory.secondaryText',
    },
    list: {
      minW: '160px',
      bg: 'entityDirectory.surface',
      borderColor: 'entityDirectory.border',
      borderRadius: 0,
      color: 'entityDirectory.text',
    },
    item: {
      color: 'entityDirectory.text',
      _focus: { background: 'entityDirectory.raisedSurface' },
      _hover: { background: 'entityDirectory.raisedSurface' },
    },
  },
};

export default config.defineMultiStyleConfig({ baseStyle, variants });
